/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { ReactFragment } from 'react';
import { Box, Text } from 'grommet';
import { BrandColors, MaterialIcon } from '@blend/enterprise-components';
import { CredentialReviewType } from 'blb-constants/ron';
import * as Ron from 'blb-ui-types/ron';

export namespace ReviewCredential {
  export interface Props {
    reviews: Ron.API.CredentialReview[];
  }
}

export const ReviewMessageList: React.FC<ReviewCredential.Props> = ({ reviews }) => {
  const renderReviewMessages = (): ReactFragment => {
    return reviews.map((review, index) => {
      if (review.type === CredentialReviewType.APPROVE) {
        return (
          <Box
            background="accentGreen07"
            border={{ color: 'accentGreen' }}
            data-it={`it-ReviewMessageList-${review.id}`}
            direction="row"
            gap="xxsmall"
            key={index}
            pad={{ horizontal: 'medium', vertical: 'small' }}
            round="xxsmall"
          >
            <MaterialIcon color={BrandColors.ACCENT_GREEN} size={24} type="check_circle" />
            <Text weight="bold">Approval notes:</Text>
            <Text>{review.adminNotes}</Text>
          </Box>
        );
      } else {
        return (
          <Box
            background="accentRed07"
            border={{ color: 'accentRed' }}
            data-it={`it-ReviewMessageList-${review.id}`}
            direction="row"
            gap="xxsmall"
            key={index}
            pad={{ horizontal: 'medium', vertical: 'small' }}
            round="xxsmall"
          >
            <MaterialIcon color={BrandColors.ACCENT_RED} size={24} type="error" />
            <Text weight="bold">Rejection reason:</Text>
            <Text>{review.adminNotes}</Text>
          </Box>
        );
      }
    });
  };

  return (
    <Box flex={false} gap="small" id="it-adminReviewMessages">
      {renderReviewMessages()}
    </Box>
  );
};
